module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"heatingTypeLabel":"Typ","costsLabel":"Kosten *","autoCostsHint":"Kosten leer lassen für automatische Kostenschätzung"}}')
  delete Component.options._Ctor
}
